import Base from "./Base"

export default {
  httpBaseUri: "https://local.impel.co:5020",
  httpServiceBaseUri: "https://local.impel.co:5020/graphql",
  wsServiceBaseUri: "wss://local.impel.co:5020/graphql",

  showConfigInTitle: true,
  configTitle: "[LOCAL]",

  theme: {
    ...Base.theme,

    logoContainer: "images-dev",
  },

  uploader: {
    ...Base.uploader,

    imageViewerBaseUri: "https://dydc66wtc7q9n.cloudfront.net",
    // imageViewerBucketName: "operandio-content-dev",
    imageViewerBucketName: "operandio-content-ap-southeast-2",
  },

  services: {
    ...Base.services,
    export: {
      ...Base.services.export,
      jobUrl: "https://lxknk3pfv9.execute-api.ap-southeast-2.amazonaws.com/prod/", // DEV account
    },
  },

  errors: {
    ...Base.errors,

    showDetail: false,
    showGraphQLErrorNotification: true,
  },
}
